import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import classNames from "classnames";
import PageBody from "../../components/Shared/PageBody";
import { PopUp } from "../../components/Shared/Info";
import { Button } from "../../components/Shared/Controls";
import HealthCard from "../../components/MedicalDocuments/HealthCard";
import { checkAvailabilityOfFeature } from "../../store";
import config from "../../../config.json";
import s from "./style.scss";
const HealthCardPage = ({ checkFeature }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [haveChanges, setHaveChanges] = useState(false);
    useEffect(() => {
        !checkFeature("HealthCard") && navigate("");
    }, []);
    const [youAreSureModal, setYouAreSureModal] = useState(false);
    const toggleYouAreSureModal = () => setYouAreSureModal(!youAreSureModal);
    const backAction = () => {
        !haveChanges
            ? navigate('/')
            : setYouAreSureModal(true);
    };
    const renderYouAreSureModal = () => {
        return React.createElement(PopUp, { style: s.removeModal, isOpen: youAreSureModal, toggle: toggleYouAreSureModal },
            React.createElement("div", { className: classNames(s.subheading_1, s.mb16) }, t("sureExitWithoutSaving")),
            React.createElement("div", { className: s.actions },
                React.createElement(Button, { style: s.button, text: t("yes"), primary: true, onClick: () => {
                        navigate('/');
                    } }),
                React.createElement(Button, { style: s.button, text: t("no"), onClick: toggleYouAreSureModal })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PageBody, { backAction: backAction, title: t("healthCardTitle") },
            React.createElement(HealthCard, { setHaveChanges: setHaveChanges, hasSidebar: true },
                renderYouAreSureModal(),
                config.design_system.showDescriptionOfFeature && React.createElement("div", { className: s.paragraph_2 }, t("uploadImagesHealthCard"))))));
};
const mapStateToProps = (state) => {
    return {
        checkFeature: (key) => checkAvailabilityOfFeature(state, key),
    };
};
export default connect(mapStateToProps)(HealthCardPage);
